// Requested days (not yet confirmed)
// Generated by scripts/build-availability.mjs from the calendar feeds; do not edit by hand.
// Each entry is [from, to]; an empty "to" is a single day. Days from today to one year ahead only.
var pending = [

];
